import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MenuService } from '../../../services/menu.service';
import { ActivatedRoute } from '@angular/router';
import { PanelModule } from '../../../modules/panel.module';
import { MenuItemOptionChoicePriceComponent } from '../menu-item-option-choice-price/menu-item-option-choice-price.component';
import { MenuItemOptionVisibilityComponent } from '../menu-item-option-visibility/menu-item-option-visibility.component';
import { Constants } from 'projects/briteatlib/src/model/common.model';

@Component({
  selector: 'brt-menu-item-option-choice',
  templateUrl: './menu-item-option-choice.component.html',
  standalone: true,
  imports: [PanelModule, MenuItemOptionChoicePriceComponent, MenuItemOptionVisibilityComponent],
  styleUrl: './menu-item-option-choice.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MenuItemOptionChoiceComponent),
      multi: true
    }
  ]
})
export class MenuItemOptionChoiceComponent {
  orderSources = Constants.OrderSources;
  
  constructor(route: ActivatedRoute, menuService: MenuService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      menuService.searchMenuOption({ BusinessId: this.businessId }).then(result => {
        this.options = result.List;
        this.filterOptions();
      });
    });
  }

  businessId: string;

  options: any[];
  filteredOptions: any[];
  private _type: string;
  @Input('type') set type(type: string) {
    this._type = type;
    this.filterOptions();
  }
  get type() { return this._type; }
  private filterOptions() { this.filteredOptions = this.options?.filter(_ => _.Type == this._type); }
  
  value: any[];
  @Output() save = new EventEmitter<any>();

  addItem() {
    this.value.push({});
    this.onChange(this.value);
  }
  removeItem(index: number) {
    this.value.splice(index, 1);
    this.onChange(this.value);
  }

  writeValue(value: any) { 
    this.value = value || []; 
    this.value.forEach(_ => {
      _.SourcePrice = _.SourcePrice || [];
    });
  }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any[]) => { };
  onTouched = () => { };
}
